import { useRef, useState } from 'react';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { Trans } from '@lingui/react/macro';
import api, { parseErrors } from 'util/api';
import { Banner } from '@thermon-platforms/thermon-ui-core';


function Modal({ device, dismiss, close }) {
  const [errors, setErrors] = useState();
  const [loading, setLoading] = useState(false);
  const forceUpdate = useRef(false);

  function doRefresh() {
    setLoading(true);
    setErrors(undefined);

    api(`/devices/${device.model.id}/refreshChild?forceUpdate=${forceUpdate.current}`, {
      method: 'PATCH'
    })
    .then(() => {
      close();
    })
    .catch(async res => {
      setErrors(parseErrors(await res.json()));
    })
    .finally(() => {
      setLoading(false);
    });
  }

  return (
    <I18nProvider i18n={i18n}>
      <header>
        <h3><Trans>Are you sure you want to refresh the controller?</Trans></h3>
      </header>
      <section>
        <Banner status="alert" show={errors}>
          <Trans>An error occurred refreshing this controller. Please, try again.</Trans>
        </Banner>
        {device.model.deviceModel == 17 ?
          <p>
            <Trans>
              T2000 circuits will lose serial number mappings during this operation.
            </Trans>
          </p>
        : null}
        <ul className="form">
          <li>
            <label htmlFor={`force-update`}>
              <input
                type="checkbox"
                name={`force-update`}
                id={`force-update`}
                defaultChecked={false}
                onChange={e => {
                  forceUpdate.current = e.target.checked;
                }}
              />
              <Trans>Force refresh all circuits</Trans>
            </label>
          </li>
        </ul>
      </section>
      <footer>
        <button onClick={dismiss}><Trans>Cancel</Trans></button>
        <button
          className={`primary ${loading ? 'processing' : ''}`}
          onClick={doRefresh}
          disabled={loading}
        >
          <Trans>OK</Trans>
        </button>
      </footer>
    </I18nProvider>
  );
}

export default Modal;
